/* eslint-disable @typescript-eslint/no-explicit-any */
import { AssetDevice } from 'app/pages/ValidationsPage/type';
import axios from 'axios';
import * as qs from 'qs';
import { getFloorPlansPayload } from 'types/floorplan';
import { FloorPlanIssuePayload } from 'types/issue';
import { ParamGetAssetIssues, ParamGetLocations } from 'types/loctions';
export const getLocations = async (params: Partial<ParamGetLocations>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/locations?${query}`);
  return data;
};
export const getLocationDetail = async (id: number) => {
  const { data } = await axios.get(`/locations/${id}`);
  return data;
};

export const updateLocationParent = async (locationId: number, parentId: number | null) => {
  const { data } = await axios.put(`/locations/${locationId}`, { parentId });
  return data;
};

export const updateLocationName = async (locationId: number, name: string) => {
  const { data } = await axios.put(`/locations/${locationId}`, { name });
  return data;
};

type CreateLocationPayload = {
  names: string[];
  clientId?: number;
  parentId?: number;
  skipLevel?: number;
};

type AddFloorPlanPayload = {
  id: number;
  file: File | null | undefined;
  name: string;
};

type GetFloorPlanPayload = {
  id: number;
};

type UpdateFloorPlanPayload = {
  locationid: number;
  floorplanid: number;
  file: File;
  name: string;
};

export const createLocation = async (payload: CreateLocationPayload) => {
  const data = await axios.post('/locations', payload);
  return data;
};

export const addFloorPlan = async (payload: AddFloorPlanPayload) => {
  const formData = new FormData();
  if (payload.file) {
    formData.append('file', payload.file);
    formData.append('name', payload.name);
  }
  const data = await axios.post(`/locations/${payload.id}/floor-plans`, formData);
  return data;
};

export const updateFloorPlan = async (payload: UpdateFloorPlanPayload) => {
  const formData = new FormData();
  if (payload.file) {
    formData.append('file', payload.file);
    formData.append('name', payload.name);
  }
  const data = await axios.put(
    `/locations/${payload.locationid}/floor-plans/${payload.floorplanid}`,
    formData
  );
  return data;
};

export const getFloorPlan = async (payload: GetFloorPlanPayload) => {
  const data = await axios.get(`/locations/${payload.id}/floor-plans`);
  return data;
};

export const getFloorPlanFilters = async () => {
  const data = await axios.get(`/locations/floor-plans/filters`);
  return data;
};

export const getFloorPlans = async (payload: getFloorPlansPayload) => {
  const { data } = await axios.post(`/locations/floor-plans`, payload);
  return data;
};

export const deleteFloorPlan = async (id: number) => {
  const data = await axios.delete(`/locations/${id}/floor-plans`);
  return data;
};

export const getFloorPlanIssues = async (floorPlanId: number) => {
  const { data } = await axios.get(`/locations/floor-plans/${floorPlanId}/issues`);
  return data;
};

export const createFloorPlanIssue = async (floorPlanId: number, payload: FloorPlanIssuePayload) => {
  const { data } = await axios.post(`/locations/floor-plans/${floorPlanId}/issues`, payload);
  return data;
};

export const updateFloorPlanIssue = async (
  floorPlanId: number,
  issueId: number,
  payload: FloorPlanIssuePayload
) => {
  const { data } = await axios.put(
    `/locations/floor-plans/${floorPlanId}/issues/${issueId}`,
    payload
  );
  return data;
};

export const deleteFloorPlanIssue = async (floorPlanId: number, issueId: number) => {
  const { data } = await axios.delete(`/locations/floor-plans/${floorPlanId}/issues/${issueId}`);
  return data;
};

export const getLocationLevelFive = async (locationId: number) => {
  const { data } = await axios.get(`/locations/${locationId}/room`);
  return data;
};

export const getAssetIssues = async (params: Partial<ParamGetAssetIssues>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/inspections/submitted-assets?${query}`);
  return data;
};
type payloadPostAppendices = {
  content?: string;
  documentIds?: number[];
  documentId?: string;
  isSelectAll?: boolean;
};

/**
 *
 * @param submitId
 * @param assetId
 */
export const deleteAssetIssues = async ({
  submitId,
  assetId
}: {
  submitId: number;
  assetId: number;
}) => {
  await axios.delete(`/inspections/locations/${submitId}/submitted-assets/${assetId}`);
};
/**
 *
 * @param submitId
 * @param assetId
 */
export const updateSubmitAsset = async ({
  submitId,
  submittedAssetId,
  payload,
  newPhotos,
  archivePhotoIds,
  deletePhotoIds
}: {
  submitId: number;
  submittedAssetId: number;
  payload: {
    name?: string;
    note?: string;
    otherNote?: string;
    // criticality?: number;
    criticalityKey?: string;
    documentIds?: string;
    typeId: number;
    modelId: number;
    condition?: string;
    validated?: boolean;
    entries?: string;
    model?: string;
    manufacturerId?: number;
    manufacturer?: string;
    options: string;
    singleFields: string;
    assetCustomId?: string;
    assetCustomId2?: string;
    lastMaintenance?: string | null;
    oemAttributes?: string;
    maintenanceEnabled?: boolean; // ← add
    assetDevices?: AssetDevice[];
  };
  newPhotos?: File[];
  /** Submitted asset photo junction ids — soft-archive (same as mobile app). */
  archivePhotoIds?: number[];
  deletePhotoIds?: number[];
}) => {
  // Create FormData for multipart request
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key.startsWith('option_')) return;
    if (key.startsWith('single_')) return;
    // handle files array
    if (key === 'photos' && Array.isArray(value)) {
      (value as any).forEach((file: File) => formData.append('files', file));
      return;
    }
    // @ts-ignore
    if (!(value instanceof File)) {
      formData.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      return;
    }

    // append single file
    formData.append(key, value);
  });

  // Add new photos
  if (newPhotos && newPhotos.length > 0) {
    newPhotos.forEach((photo) => {
      formData.append('files', photo);
    });
  }

  if (archivePhotoIds && archivePhotoIds.length > 0) {
    formData.append('archivePhotoIds', JSON.stringify(archivePhotoIds));
  }
  if (deletePhotoIds && deletePhotoIds.length > 0) {
    formData.append('deletePhotoIds', JSON.stringify(deletePhotoIds));
  }

  const { data } = await axios.put(
    `/inspections/locations/${submitId}/submitted-assets/${submittedAssetId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return data;
};

export const updateLongLat = async ({
  submitId,
  lat,
  long,
  date,
  roomId,
  clientId
}: {
  submitId: number;
  long: string;
  lat: string;
  date: string;
  clientId: number;
  roomId: number;
}) => {
  await axios.put(`/inspections/locations/${submitId}`, { long, lat, date, roomId, clientId });
};

export const updateRoomPhoto = async ({
  submitId,
  outsidePhoto,
  internalPhoto
}: {
  outsidePhoto?: File;
  internalPhoto?: File;
  submitId: number;
}) => {
  const formData = new FormData();
  if (outsidePhoto) formData.append('outside', outsidePhoto);
  if (internalPhoto) formData.append('internal', internalPhoto);
  return await axios.put(`/inspections/locations/${submitId}`, formData);
};

/**
 *
 * function create wall
 */
export const createWall = async (payload: { name: string; file: File }, id: number) => {
  const formData = new FormData();
  formData.append('files', payload.file);

  const res = await axios.post(`/storages/inspections/${id}/${payload.name}`, formData);

  return res;
};

/**
 *
 * function delete wall
 */
export const deleteWall = async ({
  submittedId,
  wall,
  ids
}: {
  submittedId: number;
  wall: string;
  ids: number[];
}) => {
  const res = await axios.put(`/storages/inspections/${submittedId}/${wall}/remove`, { ids });

  return res;
};

/** Same as mobile: archive previous row, create new, migrate photo tags (replace-photo-wall-by-id). */
export const replaceWallPhotoByIndex = async (payload: {
  submitId: number;
  wall: string;
  orderIndex: number;
  file: File;
}) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('submitId', String(payload.submitId));
  formData.append('wall', payload.wall);
  formData.append('orderIndex', String(payload.orderIndex));
  return axios.put(`/storages/inspections/replace-photo-wall-by-id`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/** Same as mobile: archive previous junction row, create new, migrate photo tags. */
export const replaceAdditionalPhotoByIndex = async (payload: {
  submitId: number;
  structureId: number;
  orderIndex: number;
  file: File;
}) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('submitId', String(payload.submitId));
  formData.append('structureId', String(payload.structureId));
  formData.append('orderIndex', String(payload.orderIndex));
  return axios.put(`/storages/inspections/replace-photo-additional-by-id`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 *
 * function delete wall
 */
export const deleteAdditionalStructure = async ({
  submittedId,
  structureId,
  ids
}: {
  submittedId: number;
  structureId: string;
  ids: number[];
}) => {
  const res = await axios.put(
    `/storages/inspections/${submittedId}/additional-structures/${structureId}/remove`,
    { ids }
  );

  return res;
};

/**
 *
 * function create additional structure
 */
export const createAdditionalStructurePhoto = async (
  payload: { file: File; structureId: string },
  id: number
) => {
  if (!id) console.log('createAdditionalStructurePhoto error ' + id);
  const formData = new FormData();
  formData.append('files', payload.file);
  const res = await axios.post(
    `/storages/inspections/${id}/additional-structures/${payload.structureId}`,
    formData
  );

  return res;
};

export const updateLocationFrequency = async ({
  locationId,
  options,
  roomCustomId,
  roomCustomId2,
  submittedId,
  complianceRepresentative
}: {
  locationId: number;
  options: Record<string, string>[];
  roomCustomId?: string;
  roomCustomId2?: string;
  submittedId?: number;
  complianceRepresentative?: string;
}) => {
  const { data } = await axios.put(`/locations/${locationId}`, {
    options,
    roomCustomId,
    roomCustomId2,
    submittedId,
    complianceRepresentative
  });
  return data;
};

type PayloadUpdateAssetIssue = {
  name?: string;
  description?: string;
  actionBy?: string;
  actionByDate?: string;
  status?: string;
  archive?: boolean;
  deletePhotoIds?: string;
  equipmentId?: string;
  note?: string | null;
  options: string;
  singleFields?: string;
  resolutionDate?: string | null;
  photoTypes?: string;
  files?: File[];
  assignedToUserId?: number;
  dueDate?: string;
  criticalityKey?: string;
};

/**
 *
 * @param submitId
 * @param assetId
 */
export const updateAssetIssues = async ({
  submitId,
  issuesId,
  assetId,
  payload
}: {
  submitId: number;
  assetId: number;
  issuesId: number;
  payload: PayloadUpdateAssetIssue;
}) => {
  const formData = new FormData();
  for (const key in payload) {
    const value = payload[key as keyof PayloadUpdateAssetIssue];
    const isArray = Array.isArray(value);

    if (value === '' && key === 'criticalityKey') {
      formData.append(key, '');
      continue;
    }

    if (value != null && value !== '' && !isArray) {
      formData.append(key, typeof value === 'string' ? value : String(value));
    }
    if (isArray) {
      value.forEach((file) => {
        formData.append('files', file);
      });
    }
  }
  await axios.put(
    `/inspections/locations/${submitId}/submitted-assets/${assetId}/issues/${issuesId}`,
    formData
  );
};

/**
 *
 * delete report issue
 */
export const deleteReportIssue = async ({
  submitted,
  id,
  issueId
}: {
  submitted: number;
  id: number;
  issueId: number;
}) => {
  if (!id || !submitted || !issueId) {
    return new Error('Cannot delete issue without id');
  }
  const { data } = await axios.put(
    `/inspections/locations/${submitted}/submitted-assets/${id}/issues/${issueId}/archive`,
    { archive: true }
  );
  return data;
};

/**
 *
 * create Asset Issues
 * @param payload
 * @param submitted
 * @param id
 */
export const createAssetIssue = async ({
  payload,
  submitted,
  id
}: {
  payload: {
    description: string;
    name: string;
    actionBy?: string;
    actionByDate: string;
    equipmentId: string;
    note?: string | null;
    uploadedFiles?: File[];
    options: Record<string, string>[];
    singleFields: Record<string, string>[];
  };
  submitted: number;
  id: number;
}) => {
  const formData = new FormData();
  formData.append('description', payload.description);
  formData.append('equipmentId', payload.equipmentId);
  if (payload.actionBy) formData.append('actionBy', payload.actionBy);
  if (payload.actionByDate) {
    formData.append('actionByDate', payload.actionByDate);
  }
  formData.append('name', payload.name);
  formData.append('options', JSON.stringify(payload.options));
  formData.append('singleFields', JSON.stringify(payload.singleFields));
  formData.append('note', payload.note || '');
  if (payload?.uploadedFiles && payload?.uploadedFiles?.length > 0) {
    payload.uploadedFiles.forEach((file) => {
      formData.append('files', file);
    });
  }
  const { data } = await axios.post(
    `/inspections/locations/${submitted}/submitted-assets/${id}/issues`,
    formData
  );
  return data;
};

export const updateReportArchiveIssues = async ({
  submitId,
  issuesId,
  assetId,
  payload
}: {
  submitId: number;
  assetId: number;
  issuesId: number;
  payload: {
    archive?: boolean;
  };
}) => {
  await axios.put(
    `/inspections/locations/${submitId}/submitted-assets/${assetId}/issues/${issuesId}/archive`,
    payload
  );
};
export const postAppendices = async (idRoom: string, payload: payloadPostAppendices) => {
  const { data } = await axios.post(`/locations/${idRoom}/appendices`, payload);
  return data;
};
export const editAppendices = async (
  idAppendix: number,
  idRoom: string,
  payload: payloadPostAppendices
) => {
  const { data } = await axios.put(`/locations/${idRoom}/appendices/${idAppendix}`, payload);
  return data;
};
export const getAppendices = async (idRoom: string, params: Partial<ParamGetAssetIssues>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/locations/${idRoom}/appendices?${query}`);
  return data;
};

export const deleteAppendix = async (idRoom: string, appendixId: number) => {
  await axios.delete(`/locations/${idRoom}/appendices/${appendixId}`);
};
export const deleteClient = async (id: number) => {
  const { data } = await axios.delete(`/locations/${id}`);
  return data;
};

export const actionExportAssets = async (params: any) => {
  const query = qs.stringify(
    {
      ...params
    },
    {
      arrayFormat: 'repeat',
      skipNulls: true
    }
  );
  const { data } = await axios.get(`/inspections/submitted-assets/export?${query}`);
  return data;
};

export const actionExportAssetTypes = async (params: any) => {
  // @ts-ignore
  const query = qs.stringify(
    { ...params },
    {
      arrayFormat: 'repeat',
      skipNulls: true
    }
  );
  const { data } = await axios.get(`/assets/types/export?${query}`);
  return data;
};

export const actionExportAssetModels = async (params: any) => {
  const query = qs.stringify(
    {
      ...params
    },
    {
      arrayFormat: 'repeat',
      skipNulls: true
    }
  );
  const { data } = await axios.get(`/assets/models/export?${query}`);
  return data;
};

export const actionExportRoomIssues = async (params: any) => {
  const query = qs.stringify(
    {
      ...params
    },
    {
      arrayFormat: 'repeat',
      skipNulls: true
    }
  );
  const { data } = await axios.get(`/reports/room-issues/export?${query}`);
  return data;
};
